<template>
  <v-card class="mt-8">
    <v-card-title class="card-title-weights"> Medidas e pesos </v-card-title>
    <v-row class="px-8">
      <v-divider></v-divider>
    </v-row>
    <v-card-text class="card-weight px-10">
      <v-row>
        <v-col cols="6">
          <p class="mt-3 texto-corrido">Configure a tag que o usuário visualiza no card do produto no e-commerce.</p>
          <v-row>
            <v-col class="py-0" cols="4">
              <v-text-field
                v-model="productForms.quantityDescription"
                label="Tag"
                outlined
                height="44px"
                :disabled="!userHasPermission"
                :error="validation.product.quantityDescription.$error"
                :error-messages="quantityDescriptionError"
              />
            </v-col>
          </v-row>
          <div class="product-toggle d-none">
            <mf-toggle v-model="productForms.isWeightable" class="pb-n10" label="Produto vendido por medida" hide-details />
          </div>
          <p class="mt-3 texto-corrido d-none">Configure a medida e o peso base do produto pesável.</p>
          <div>
            <h3>Medida</h3>
            <v-row>
              <v-col class="py-0" cols="4">
                <v-select
                  v-model="productForms.measure"
                  :items="measures"
                  outlined
                  color="#C3C8CD"
                  height="44px"
                  item-text="name"
                  return-object
                  :disabled="!userHasPermission"
                  :error="validation.product.measureMfId && validation.product.measureMfId.$error"
                  :error-messages="measureError"
                />
              </v-col>
            </v-row>
          </div>
          <div v-if="productForms.measure && productForms.measure.fractionalSale">
            <v-text-field
              v-model="productForms.initialWeight"
              label="Peso inicial"
              outlined
              height="44px"
              messages="É o peso em gramas que ficará pré-selecionado no campo quantidade(ex. 500g)"
              type="number"
              min="0"
              :disabled="!userHasPermission"
              :error="validation.product.initialWeight && validation.product.initialWeight.$error"
              :error-messages="initialWeightError"
              @keydown="$event.key === '-' || $event.key === 'e' ? $event.preventDefault() : null"
            >
              <template slot="append-outer">
                <div v-if="productForms.measure && productForms.measure.acronym && productForms.measure.acronym.length" class="py-1 px-2 append-item">
                  <span class="append-item-text">{{ productForms.measure.acronym }}</span>
                </div>
              </template>
            </v-text-field>
            <v-text-field
              v-model="productForms.additionWeight"
              class="mt-5"
              label="Peso de acréscimo"
              outlined
              height="44px"
              :messages="additionWeightMessage"
              type="number"
              min="0"
              :disabled="!userHasPermission"
              :error="validation.product.additionWeight && validation.product.additionWeight.$error"
              :error-messages="additionalWeightError"
              @keydown="$event.key === '-' || $event.key === 'e' ? $event.preventDefault() : null"
            >
              <template slot="append-outer">
                <div v-if="productForms.measure && productForms.measure.acronym && productForms.measure.acronym.length" class="py-1 px-2 append-item">
                  <span class="append-item-text">{{ productForms.measure.acronym }}</span>
                </div>
              </template>
            </v-text-field>
          </div>
        </v-col>
        <v-col cols="6">
          <v-row>
            <v-col class="py-0">
              <h3 class="subtitle preview-text">Preview</h3>
              <div class="preview-box pa-3">
                <v-card style="position: relative" min-height="80px">
                  <div v-if="productForms.quantityDescription" class="preview-box-chip">
                    <span>
                      {{ productForms.quantityDescription }}
                    </span>
                  </div>
                  <div class="pa-3">
                    <v-img v-if="productForms.images[0].url" :src="productForms.images[0].url" />
                  </div>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ProductWeightsMeasures',
  inject: ['userHasPermission'],
  props: {
    value: {
      type: Object,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    measures: {
      type: Array,
      required: true,
    },
  },
  data: () => ({}),
  computed: {
    productForms: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    measureError() {
      if (this.validation.product.measure && this.validation.product.measure.name.$error) return 'Campo obrigatório'
      return ''
    },
    initialWeightError() {
      if (this.validation.product.initialWeight && this.validation.product.initialWeight.$error) {
        if (!this.validation.product.initialWeight.minValue) {
          return 'Peso inicial deve ser maior que 0'
        }

        return 'Campo obrigatório'
      }
      return ''
    },
    quantityDescriptionError() {
      if (this.validation.product.quantityDescription && this.validation.product.quantityDescription.$error) return 'Deve conter no máximo 8 caracteres'
      return ''
    },
    additionalWeightError() {
      if (this.validation.product.additionWeight && this.validation.product.additionWeight.$error) {
        if (!this.validation.product.additionWeight.minValue) {
          return 'Peso acréscimo deve ser maior que 0'
        }

        return 'Campo obrigatório'
      }
      return ''
    },
    additionWeightMessage() {
      return `É o peso em gramas que irá acrescentar cada vez que o cliente clicar em "+"`
    },
  },
  methods: {},
}
</script>

<style lang="scss">
.card-title-weights {
  color: $cinza-d10;
  font-weight: 700;
}
.card-weight {
  .v-input,
  .v-input input,
  .v-input textarea,
  .v-select .v-select__selection--comma {
    color: $cinza-0 !important;
  }

  .v-text-field--filled > .v-input__control > .v-input__slot,
  .v-text-field--full-width > .v-input__control > .v-input__slot,
  .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 0 !important;
  }

  .v-text-field--outlined .v-label {
    top: 12px;
  }

  .v-label--active {
    top: 18px !important;
    color: $marca-0 !important;
  }

  .v-text-field--enclosed .v-input__append-inner,
  .v-text-field--enclosed .v-input__append-outer,
  .v-text-field--enclosed .v-input__prepend-inner,
  .v-text-field--enclosed .v-input__prepend-outer,
  .v-text-field--full-width .v-input__append-inner,
  .v-text-field--full-width .v-input__append-outer,
  .v-text-field--full-width .v-input__prepend-inner,
  .v-text-field--full-width .v-input__prepend-outer {
    margin-top: 11px;
  }

  .append-item {
    min-width: 105px;
    color: $cinza-l20;
    text-align: center;
    background-color: $cinza-l90;
    border-radius: 4px;
  }

  .append-item-text {
    font-size: 14px;
    font-family: 'Lato';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
  }

  .preview-box {
    width: 166px;
    height: 84px;
    overflow: hidden;
    background-color: $cinza-l90;
  }

  .preview-box-chip {
    position: absolute;
    top: 10px;
    left: 10px;
    min-width: 61px;
    height: 24px;
    background-color: $cinza-l90;
    display: flex;
    justify-content: center;
    color: $cinza-l10;
    border-radius: 16px !important;
    z-index: 1;
  }

  .preview-text {
    font-size: 16px !important;
    color: $cinza-d20 !important;
  }

  .product-toggle {
    .v-label {
      font-size: 16px !important;
      color: $cinza-d20 !important;
    }
  }
}
</style>
